var ViewPort = (function () {
    function ViewPort() {
    }
    return ViewPort;
}());
export { ViewPort };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlldy1wb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidmlldy1wb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0lBQUE7SUFVQSxDQUFDO0lBQUQsZUFBQztBQUFELENBQUMsQUFWRCxJQVVDIn0=